import ConnectedIcon from '@clearkit/icons/indicators/ConfigConnected';

import Logo from '~/components/ConfigurationLogo';
import { configurationNameForType } from '~/lib/configuration';

import styles from './styles.js';

const Connected = ({ classes, connector, children }) => {
  const name = configurationNameForType(connector.service);

  return (
    <div className={classes.root}>
      <div className={classes.dottedLogo}>
        <Logo type={connector.service} style={{ width: 40, height: 40 }} />
      </div>
      <div className={classes.title}>
        <ConnectedIcon className={classes.connectedIcon} />
        <span>Connected to {name}</span>
      </div>
      {React.Children.count(children) ? <hr className={classes.break} /> : null}
      {children}
    </div>
  );
};

Connected.propTypes = {
  children: PropTypes.node,
  connector: PropTypes.shape({
    name: PropTypes.string,
  }),
};

export default withStyles(styles)(Connected);
